import React from "react";
import {Table} from "react-bootstrap";
import locale from "../../../../locale";

export default ({polls, event, onAnswerClick}) => {
    if (!polls.length) return null;

    const ShowClientsLink = ({poll, answer, children}) => {
        if (!event.client.allowPrivateClientDataAccess || !poll.authorizationRequired) {
            return children;
        }

        return <a onClick={() => onAnswerClick(answer)}>{children}</a>;
    };

    const PollAnswerResult = ({poll, answer}) => {
        // if ('rating' === poll.type) {
        //     return answer.count > 0 ? (Math.round(answer.ratingSum / answer.count * 10) / 10) : 0;
        // }

        return answer.count;
    };

    let prevPoll = null
    return (
        <section>
            {polls.map(poll => {
                const pollComponent = (
                    <div key={poll.id}>
                        {(null === prevPoll || prevPoll.streamId !== poll.streamId) &&
                            <h4 style={{fontWeight: "bold"}}>{poll.streamDescription}</h4>
                        }
                        <Table>
                            <thead>
                            <tr>
                                <th>
                                    <span>{poll.textRu}</span>
                                    <span style={{marginLeft: 10, color: 'red', fontWeight: 'normal'}}>{locale('poll.type.' + poll.type)}</span>
                                </th>
                                <th style={{width: 80}}>Зрители</th>
                            </tr>
                            </thead>
                            <tbody>
                            {poll.answer.map(answer =>
                                <tr key={answer.id}>
                                    <td>
                                        <ShowClientsLink poll={poll} answer={answer}>{answer.textRu}</ShowClientsLink>
                                    </td>
                                    <td>
                                        <PollAnswerResult poll={poll} answer={answer} />
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </div>
                );

                prevPoll = poll;

                return pollComponent;
            })}
        </section>
    );
}
